// src/components/CareerForm.js

import React, { useState, useEffect } from 'react';
import { TextField, Button, Container, Box } from '@mui/material';
import { createCareer, getCareerById, updateCareer } from '../services/careerService';
import { useParams, useNavigate } from 'react-router-dom';
import DashboardLayout from './DashboardLayout';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

function CareerForm() {
  const [initialValues, setInitialValues] = useState({
    position: '',
    description: '',
  });
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      fetchCareer();
    }
  }, [id]);

  const fetchCareer = async () => {
    try {
      const data = await getCareerById(id);
      setInitialValues({
        position: data.position,
        description: data.description,
      });
    } catch (error) {
      console.error('Error fetching career:', error);
    }
  };

  const CareerSchema = Yup.object().shape({
    position: Yup.string().required('Position is required'),
    description: Yup.string(),
  });

  const handleSubmit = async (values) => {
    try {
      if (id) {
        await updateCareer(id, values);
      } else {
        await createCareer(values);
      }
      navigate('/careers');
    } catch (error) {
      console.error('Error saving career:', error);
    }
  };

  return (
    <DashboardLayout>
      <Container maxWidth="sm">
        <Box mt={4}>
          <Formik
            initialValues={initialValues}
            enableReinitialize
            validationSchema={CareerSchema}
            onSubmit={handleSubmit}
          >
            {({ values, errors, touched, handleChange }) => (
              <Form>
                <TextField
                  label="Position"
                  name="position"
                  value={values.position}
                  onChange={handleChange}
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  required
                  error={touched.position && Boolean(errors.position)}
                  helperText={touched.position && errors.position}
                />
                <TextField
                  label="Description"
                  name="description"
                  value={values.description}
                  onChange={handleChange}
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  multiline
                  rows={4}
                />
                <Box mt={2}>
                  <Button type="submit" variant="contained" color="primary">
                    {id ? 'Update Career' : 'Create Career'}
                  </Button>
                </Box>
              </Form>
            )}
          </Formik>
        </Box>
      </Container>
    </DashboardLayout>
  );
}

export default CareerForm;
